export const SEND_CONTACT_FORM = 'SEND_CONTACT_FORM';
export const SET_IS_FETCHED = 'SET_IS_FETCHED';
export const SET_HAS_ERROR = 'SET_HAS_ERROR';
